<template>
  <table class="dashboard-task-table max-w-screen mx-auto bg-white" style="border-spacing: 0">
    <thead>
      <tr class="z-5 sticky top-0 bg-white/90 backdrop-filter">
        <th
          class="sticky left-3 z-20 border border-slate-300 bg-white/90 py-2 text-left font-bold capitalize text-gray-600 dark:border dark:border-white dark:bg-slate-700 dark:text-gray-300"
        >
          <span class="flex flex-row items-center gap-2 px-3">
            {{ $t('attributes.task') }}
          </span>
        </th>
        <th
          class="border border-slate-300 px-3 py-2 capitalize text-gray-600 dark:border dark:border-white dark:bg-slate-700 dark:text-gray-300"
        >
          {{ $t('attributes.responsable') }}
        </th>
        <th
          class="border border-slate-300 px-3 py-2 capitalize text-gray-600 dark:border dark:border-white dark:bg-slate-700 dark:text-gray-300"
        >
          {{ $t('attributes.status') }}
        </th>
        <th
          class="border border-slate-300 px-3 py-2 capitalize text-gray-600 dark:border dark:border-white dark:bg-slate-700 dark:text-gray-300"
        >
          {{ $t('attributes.due_date') }}
        </th>
        <th
          class="border border-slate-300 px-3 py-2 capitalize text-gray-600 dark:border dark:border-white dark:bg-slate-700 dark:text-gray-300"
        >
          {{ $t('attributes.remarks') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="task in tasks"
        :key="task.id"
        class="cursor-pointer hover:bg-gray-50"
        @click="openTask(task)"
      >
        <td
          class="sticky left-3 whitespace-nowrap border border-t-0 border-slate-300 bg-white/90 px-5 py-2 pr-3 text-left font-medium backdrop-filter dark:border dark:border-white dark:bg-slate-700 dark:text-white"
        >
          {{ $trans(task.name) }}
        </td>
        <td
          class="whitespace-nowrap border border-l-0 border-t-0 border-slate-300 bg-white text-center dark:border dark:border-white dark:bg-slate-700 dark:text-white"
        >
          <div v-if="responsableId(task)">
            <AvatarComponent :user_id="responsableId(task)" />
          </div>
        </td>
        <td
          class="whitespace-nowrap border border-l-0 border-t-0 border-slate-300 bg-white px-3 text-center dark:border dark:border-white dark:bg-slate-700 dark:text-white"
        >
          <TaskComponent
            v-if="task"
            :task="task"
            block-placement="top"
            line-placement="center"
            @click.stop
          />
        </td>
        <td
          class="whitespace-nowrap border border-l-0 border-t-0 border-slate-300 bg-white px-3 text-center dark:border dark:border-white dark:bg-slate-700 dark:text-white"
        >
          {{ dueDate(task) ?? $t('global.undefined') }}
        </td>
        <td
          class="border border-l-0 border-t-0 border-slate-300 bg-white px-3 text-left dark:border dark:border-white dark:bg-slate-700 dark:text-white"
        >
          {{ remarks(task) }}
        </td>
      </tr>
    </tbody>
  </table>
  <TaskDossierModal
    v-model:open="modalOpened"
    v-model:edition-mode="modalEditionMode"
    :task-id="selectedTaskId"
    @refresh-list="$emit('refresh-list')"
  />
</template>
<script>
import TaskComponent from '@c/TaskComponent'
import AvatarComponent from '@c/AvatarComponent.vue'
import TaskDossierModal from '@c/baseComponents/modal/taskDossier/TaskDossierModal.vue'

export default {
  name: 'TaskRowsTable',
  components: { AvatarComponent, TaskComponent, TaskDossierModal },
  props: {
    tasks: {
      type: Array,
      required: true
    }
  },
  emits: ['refresh-list'],
  data() {
    return {
      modalOpened: false,
      modalEditionMode: false,
      selectedTaskId: null
    }
  },
  methods: {
    openTask(task) {
      this.selectedTaskId = task.id
      this.modalOpened = true
      this.modalEditionMode = false
    },
    responsableId(task) {
      return task.responsable_id ?? task.users?.manager_id ?? null
    },
    dueDate(task) {
      if (!task.due_date_time) {
        return null
      }
      if (typeof task.due_date_time === 'string' && task.due_date_time.includes('-') && !task.due_date_time.includes('T')) {
        return task.due_date_time
      }
      return this.$h.formatDate(task.due_date_time, 'DD-MM-YY HH:mm')
    },
    remarks(task) {
      return this.$trans(task.remarks)
    }
  }
}
</script>
<style scoped>
.dashboard-task-table {
  max-width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
  table-layout: auto;
  width: 100%;
}
</style>
